export default "/fr/_next/static/assets/icons/android/android-chrome-192x192.dff3146d2f39f776ffa2357f1f52ea04.png";